if (!("remove" in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

const heightBreakepoint = 685,
  header_cityDropdownID = "#block-views-block-city-menu-block-1-4",
  header_cityDropdown_new_ID =
    "#block-blazingsaddles-views-block-city-menu-block-1-new",
  header_languageDrowdown = ".js-language-menu",
  inner_cityDropdownID = "#block-views-block-city-menu-block-1-3",
  inner_callUsDropdownID = "#block-views-block-call-us-menu-block-1-2",
  hamburgerIcon = document.getElementById("menu-icon"),
  fullscreenMenu = document.getElementById("fullscreen-menu"),
  reserveNowBtn = document.querySelector(
    ".header-menu-box .reserve-now-button.bicycle"
  ),
  bookNowBtn = document.querySelector(
    "#block-blazingsaddles-sanfranciscobooknowbutton"
  ),
  visitUsBtn = document.querySelector(
    "#block-blazingsaddles-headervisitus"
  ),
  headerCallBtn = document.querySelector(
    "#block-blazingsaddles-headerphone"
  ),
  ImportantButtons = [hamburgerIcon, bookNowBtn, visitUsBtn, headerCallBtn],
  _mobilebreakpoint = 768;

let isMobileView,
  movedButtons = [];

let header = document.getElementById("header"),
  slideButtons = getButtonsBeforeCityDropdown(),
  isFullPage = document.querySelector("body.page-node-type-locations");

hamburgerIcon.addEventListener("click", () => {
  if (!hamburgerIcon.classList.contains("opened")) {
    if (window.innerWidth < _mobilebreakpoint) {
      document.querySelector(".fullscreen-menu-bottom").style.transform =
        "translateX(0)";
    }

    fullscreenMenu.classList.add("opened");
    hamburgerIcon.classList.add("opened");

    document.body.classList.add("non-scrollable");
    header.classList.add("opened");

    if (isFullPage) {
      fullpage_api.setAllowScrolling(false);
    }

    if (document.querySelector(header_cityDropdownID)) {
      slideButtons = getButtonsBeforeCityDropdown();
      Array.from(slideButtons).map((button) => {
        button.classList.add("buttonslide");
      });
    }

    /* document.querySelector("#page-content").style.display = "none";
    document.querySelector("#page-footer").style.display = "none"; */
  } else {
    fullscreenMenu.classList.remove("opened");
    hamburgerIcon.classList.remove("opened");
    document.body.classList.remove("non-scrollable");
    header.classList.remove("opened");

    if (isFullPage) {
      fullpage_api.setAllowScrolling(true);
    }

    if (document.querySelector(header_cityDropdownID)) {
      slideButtons = getButtonsBeforeCityDropdown();
      Array.from(slideButtons).map((button) => {
        button.classList.remove("buttonslide");
      });
    }

    /* document.querySelector("#page-content").style.display = "block";
    document.querySelector("#page-footer").style.display = "flex"; */
  }
});

if (document.body.classList.contains("page-node-type-locations")) {
  document.querySelector("html").classList.add("location-page");
}

function getButtonsBeforeCityDropdown() {
  let buttons = document.querySelectorAll("#header .header-menu-box > *");
  let beforeBtns = [];
  if (header_cityDropdownID) {
    let i = 0;
    while (
      buttons[i] !== document.querySelector(header_cityDropdownID) &&
      i < buttons.length
    ) {
      beforeBtns.push(buttons[i]);
      i++;
    }
    return beforeBtns;
  } else return null;
}

if (document.readyState !== "loading") {
  onReady();
} else {
  window.addEventListener("load", () => {
    onReady();
  });
}

//onReady();

let menuRed = document.querySelectorAll(".menu-title-red");
menuRed.forEach((redmenu) => {
  redmenu.parentElement.classList.add("hidebefore");
});

function onReady() {
  renderCityDropdown(header_cityDropdownID);
  renderCityDropdown(header_cityDropdown_new_ID);
  //renderLanguageDropdown(header_languageDrowdown);
  removeOtherCityMenus();
  renderCityDropdown(inner_cityDropdownID);
  setButtonEvents();
  mobileMenu();
  if (document.querySelector("#full-page-wrapper")) {
    document.querySelector("#full-page-wrapper").style.transform = "none";
  }
  //Its remove the book now button
  /* initializeButtonWrap(); */

  //document.querySelector("#page-header").style.visibility = "visible";
}

function mobileMenu() {
  if (window.innerWidth < _mobilebreakpoint) {
    fullscreenMenu.style.height = window.innerHeight - 80 + "px";
  } else {
    fullscreenMenu.style.height = "100vh";
  }

  /* if (window.innerWidth < _mobilebreakpoint && !isMobileView) {
    let level1items = document.querySelectorAll(
      "#block-locationmenu .level-1-item"
    );
    let menus = document.querySelectorAll("#block-locationmenu .level-1-item");
    let container = document.createElement("div");
    container.classList.add("level-1-item-clone");
    level1items = Array.from(level1items).map((item) => {
      let newItem;
      newItem = item.querySelector("a");
      newItem.savedHref = newItem.attributes.href;
      if (item.querySelector("ul")) {
        newItem.removeAttribute("href");
      }
      newItem.addEventListener("click", function () {
        document.querySelector(".fullscreen-menu-bottom").style.transform =
          "translateX(0)";
      });
      newItem = newItem.cloneNode(true);
      newItem.SubMenu = item;
      if (item.querySelector("ul")) {
        newItem.classList.add("has-submenus");
        newItem.removeAttribute("href");
        newItem.addEventListener("click", function () {
          menus.forEach((menu) => {
            if (menu !== newItem.SubMenu) {
              menu.style.display = "none";
            } else {
              menu.style.display = "block";
            }
          });
          document.querySelector(".fullscreen-menu-bottom").style.transform =
            "translateX(-100%)";
        });
      }

      return newItem;
    });
    level1items.forEach((item) => container.appendChild(item));
    let mainmenu = document.getElementById("block-blazingsaddles-main-menu");
    mainmenu.insertBefore(
      container,
      document.querySelector("#block-blazingsaddles-main-menu > *:nth-child(1)")
    );
    isMobileView = true;
  } else if (window.innerWidth > _mobilebreakpoint && isMobileView) {
    let level1itemsLI = document.querySelectorAll(
      "#block-locationmenu .level-1-item"
    );
    level1itemsLI.forEach((item) => {
      item.style.display = "block";
    });
    document
      .querySelector("#block-blazingsaddles-main-menu .level-1-item-clone")
      .remove();
    let level1items = document.querySelectorAll(
      "#block-locationmenu .level-1-item > a"
    );
    level1items.forEach((item) => {
      document.querySelector(".fullscreen-menu-bottom").style.transform =
        "none";
      item.setAttribute("href", item.savedHref.value);
    });
    isMobileView = false;
  } */
}

function initializeButtonWrap() {
  let container = document.querySelector("#header .fullscreen-menu-top");
  movedButtons = [];
  if (window.bsLocation !== "") {
    responsiveHeaderButtonWrap(container, ImportantButtons);

    window.addEventListener("resize", function () {
      responsiveHeaderButtonWrap(container, ImportantButtons);
    });
  } else {
    mainpage_responsiveHeaderButtonWrap(container, [hamburgerIcon]);

    window.addEventListener("resize", function () {
      mainpage_responsiveHeaderButtonWrap(container, [hamburgerIcon]);
    });
  }
}

function responsiveHeaderButtonWrap(TargetContainer, ImportantButtons) {
  let freeSpace = getFreeSpace();
  let mainButtons = getMovableButtons(ImportantButtons);
  let isOpened;

  if (freeSpace <= 0) {
    if (0 < mainButtons.length) {
      button = mainButtons[0];
      button.savedWidth = button.offsetWidth; // Elmenti a szélességét (Ha bekerül a belmenübe display:none miatt kinullázódik)
      button.nextItem = button.nextElementSibling; // Elmenti a szomszéd elemet, hogy vissza lehessen szúrni a megfelelő helyre.
      movedButtons.unshift(button);
      if (
        button !== document.querySelector(header_cityDropdownID) &&
        window.bsLocation !== ""
      ) {
        TargetContainer.appendChild(button);
      } else {
        slideButtons.forEach((btn) => {
          btn.classList.remove("buttonslide");
        });
        button.remove(); // A lenyíló city menüt nem adja hozzá a belmenühöz, mert az már alapból tartalmazza.
      }
      responsiveHeaderButtonWrap(TargetContainer, ImportantButtons);
    }
  } else if (0 < movedButtons.length) {
    // Visszarak button-öket
    if (movedButtons[0].savedWidth < freeSpace) {
      document
        .querySelector("#header .header-menu-box")
        .insertBefore(movedButtons[0], movedButtons[0].nextItem);
      isOpened = document.querySelector("#header.opened");
      if (isOpened) {
        if (movedButtons[0] === document.querySelector(header_cityDropdownID)) {
          slideButtons.forEach((btn) => {
            btn.classList.add("buttonslide");
          });
        } else if (slideButtons.includes(movedButtons[0])) {
          movedButtons[0].classList.add("buttonslide");
        }
      }
      movedButtons.shift();
    }
  }
}

function mainpage_responsiveHeaderButtonWrap(
  TargetContainer,
  ImportantButtons
) {
  let freeSpace = getFreeSpace();
  let mainButtons = getMovableButtons(ImportantButtons);
  if (freeSpace <= 0) {
    // Elvesz button-öket
    if (0 < mainButtons.length) {
      button = mainButtons[0];
      button.savedWidth = button.offsetWidth; // Elmenti a szélességét (Ha bekerül a belmenübe display:none miatt kinullázódik)
      button.nextItem = button.nextElementSibling; // Elmenti a szomszéd elemet, hogy vissza lehessen szúrni a megfelelő helyre.
      movedButtons.unshift(button);
      button.remove(); // A lenyíló city menüt nem adja hozzá a belmenühöz, mert az már alapból tartalmazza.
    }
    responsiveHeaderButtonWrap(TargetContainer, ImportantButtons);
  } else if (0 < movedButtons.length) {
    // Visszarak button-öket
    if (movedButtons[0].savedWidth < freeSpace) {
      document
        .querySelector("#header .header-menu-box")
        .insertBefore(movedButtons[0], movedButtons[0].nextItem);
      isOpened = document.querySelector("#header.opened");
      movedButtons.shift();
    }
  }
}

function getMovableButtons(ImportantButtons = []) {
  let buttons = document.querySelectorAll("#header .header-menu-box > *"); // Mozgatható button-ök, amik épp a fejlécben vannak
  // Kiveszi a tömbből azokat a button-öket, amiket nem akarunk mozgatni
  if (ImportantButtons) {
    buttons = Array.from(buttons).filter(
      (button) => !ImportantButtons.includes(button)
    );
  }
  return buttons;
}

function getFreeSpace() {
  let headerFull = document.querySelector("#header .header-menu");
  let buttonContainer = document.querySelector("#header .header-menu .section");

  if (window.innerWidth < _mobilebreakpoint) {
    return headerFull.clientWidth - buttonContainer.clientWidth - 10; // Outer container - inner container - left and right padding
  } else {
    return headerFull.clientWidth - buttonContainer.clientWidth - 2 * 40; // Outer container - inner container - left and right padding
  }
}

function renderCityDropdown(containerID) {
  let cityMenu = document.querySelector(containerID);
  let cityMenuContent = document.querySelector(containerID + " .view-content");

  if (cityMenu) {
    let activeCity = document.querySelector(containerID + " .active");
    let activeCityCollection = document.querySelectorAll(
      containerID + " .active"
    );

    if (activeCityCollection.length > 1) {
      //Array.from(activeCityCollection).filter((item, index) => index > 0).map(city => city.classList = "non-active  views-row");

      for (let i = 1; i < activeCityCollection.length; i++) {
        activeCityCollection[i].classList.remove("active");
        activeCityCollection[i].classList.add("non-active");
      }
    }

    if (activeCity) {
      activeCity.style.order = "1";
    }

    let activeATag = document.querySelector(containerID + " .active a");

    if (activeATag) activeATag.removeAttribute("href");

    let citiesContainer = document.createElement("div");
    citiesContainer.classList.add("city-options");

    let cityOptions = document.querySelectorAll(
      containerID + " div.non-active"
    );

    let cityHeader = document.querySelector(containerID + " .view-header");
    citiesContainer.appendChild(cityHeader);

    cityOptions.forEach((option) => {
      citiesContainer.appendChild(option);
    });

    cityMenuContent.appendChild(citiesContainer);

    document
      .querySelector(
        containerID + " .view-content .field-content > a:first-child"
      )
      .addEventListener("click", function () {
        cityMenuContent.classList.toggle("opened");
      });

    window.addEventListener("click", function (e) {
      if (
        cityMenuContent.classList.contains("opened") &&
        !e.target.matches(
          containerID +
            ".active, " +
            containerID +
            " .active div, " +
            containerID +
            " .active a"
        )
      ) {
        cityMenuContent.classList.remove("opened");
      }
    });
  }
}

function removeOtherCityMenus() {
  // A nem szükséges almenük törlése a full-screen menüből
  // Deleting the unnecessary sub-menus from the full-screen menu
  let subMenuCollection = document.querySelectorAll(
    "#block-locationmenu > ul > li"
  );
  subMenuCollection.forEach((subMenu) => {
    if ("/" + window.bsLocation != subMenu.children[0].attributes.href.value) {
      subMenu.remove();
    }
  });
}

function setMenuColumns() {
  // A menücsomópontokat külön oszlopokba szedi.
  // Seperate menu ul-s to different columns.
  const menuUl = document.querySelector("#block-locationmenu > ul > li > ul");
  const menuColumn = document.querySelectorAll(
    "#block-locationmenu > ul > li > ul > li"
  );
  if (menuColumn) {
    if (2 <= menuColumn.length) {
      menuColumn[0].classList.add("first-menu-column");
      let menuColumnDiv = document.createElement("div");
      menuColumnDiv.classList.add("second-menu-column");
      for (let i = 1; i < menuColumn.length; i++) {
        menuColumnDiv.appendChild(menuColumn[i]);
      }
      menuUl.appendChild(menuColumnDiv);
    }
  }
}

function renderLanguageDropdown(container) {
  // Nyelv választó dropdown menü
  // Language selection dropdown menu
  const languageMenu = document.querySelector(container + " > ul");
  let activeLanguage = document.querySelector(container + " > ul .is-active");
  if (languageMenu) {
    if (!activeLanguage)
      activeLanguage = document.querySelector(container + ' > ul a[href="/"]');

    activeLanguage.parentElement.style.order = "1";
    activeLanguage.parentElement.classList.add("selected-language");
    activeLanguage.removeAttribute("href");
    let optionContainer = document.createElement("div");
    optionContainer.classList.add("options");
    let languageOptions = document.querySelectorAll(
      container + " > ul > li:not(.selected-language)"
    );
    languageOptions.forEach((option) => {
      optionContainer.appendChild(option);
    });
    languageMenu.appendChild(optionContainer);

    languageMenu.addEventListener("click", function () {
      this.classList.toggle("opened");
    });

    window.addEventListener("click", function (e) {
      if (
        languageMenu.classList.contains("opened") &&
        !e.target.matches(".selected-language, .selected-language a")
      ) {
        languageMenu.classList.remove("opened");
      }
    });
  }
}

function setButtonEvents() {
  const cityMenuFront = document.querySelector(
    "#block-views-block-city-menu-block-1-2"
  );

  if (cityMenuFront) {
    cityMenuFront.addEventListener("click", function () {
      this.classList.toggle("opened");
    });
  }

  const cityMenuFront2 = document.querySelector(
    "#block-views-block-city-menu-block-1-3"
  );

  if (cityMenuFront2) {
    cityMenuFront2.addEventListener("click", function () {
      this.classList.toggle("opened");
    });
  }

  const callUs = document.querySelector(
    "#block-views-block-call-us-menu-block-1"
  );

  if (callUs) {
    callUs.addEventListener("click", function () {
      this.classList.toggle("opened");
    });
  }

  const callUs2 = document.querySelector(
    "#block-views-block-call-us-menu-block-1-2"
  );

  if (callUs2) {
    callUs2.addEventListener("click", function () {
      this.classList.toggle("opened");
    });
  }

  // dropdown-ok becsukása, ha az elemen kívül kattintunk bárhol az ablakban.
  // Closing dropdowns, if we click anywhere in the window outside of the element
  window.addEventListener("click", function (e) {
    if (cityMenuFront) {
      if (
        cityMenuFront.classList.contains("opened") &&
        !e.target.matches(
          "#block-views-block-city-menu-block-1-2, #block-views-block-city-menu-block-1-2 .block-title, #block-views-block-city-menu-block-1-2 .block-title-inner"
        )
      ) {
        cityMenuFront.classList.remove("opened");
      }
    }

    if (cityMenuFront2) {
      if (
        cityMenuFront2.classList.contains("opened") &&
        !e.target.matches(
          "#block-views-block-city-menu-block-1-3, #block-views-block-city-menu-block-1-3 .block-title, #block-views-block-city-menu-block-1-3 .block-title-inner"
        )
      ) {
        cityMenuFront2.classList.remove("opened");
      }
    }

    if (callUs) {
      if (
        callUs.classList.contains("opened") &&
        !e.target.matches(
          "#block-views-block-call-us-menu-block-1, #block-views-block-call-us-menu-block-1 .block-title, #block-views-block-call-us-menu-block-1 .block-title-inner"
        )
      ) {
        callUs.classList.remove("opened");
      }
    }

    if (callUs2) {
      if (
        callUs2.classList.contains("opened") &&
        !e.target.matches(
          "#block-views-block-call-us-menu-block-1-2, #block-views-block-call-us-menu-block-1-2 .block-title, #block-views-block-call-us-menu-block-1-2 .block-title-inner"
        )
      ) {
        callUs2.classList.remove("opened");
      }
    }
  });
}

navbar = document.getElementById("page-header");

// Fejléc lejjebb pozícionálása, hogy elférjen a drupal admin toolbar bejelntkezett álapotban.
// Positioning lower the header, so drupal's admin toolbar can fit in logged-in state
let adminToolBar = document.getElementById("toolbar-administration");
if (adminToolBar) {
  navbar.style.top = "79px";
}

navbar.treshold = 20;
const fullpageDiv = document.getElementById("full-page-wrapper");
window.onload = function () {
  setTreshold();
  setStickyMenuDynamically();
  window.onscroll = () => {
    setTreshold();
    setStickyMenuDynamically();
  };
  // Fullpage-es (desktop) verzió a navigation.js fájlban található, a fullpage configon belül!!!
};

window.addEventListener("resize", function () {
  setStickyMenuDynamically();
  mobileMenu();
  setTreshold();
  if (document.querySelector("#full-page-wrapper")) {
    document.querySelector("#full-page-wrapper").style.transform = "none";
  }
});

function setTreshold() {
  let TourSubpage = document.querySelector("body.page-node-type-tour"); //túra beloldal
  let EventTour = document.querySelector("body.page-node-type-event-tour");
  let Alcatraz = document.querySelector("body.page-node-type-tour-package");
  if (
    (TourSubpage || EventTour || Alcatraz) &&
    window.innerWidth <= _mobilebreakpoint
  ) {
    //navbar.classList.add("sticky");
    navbar.treshold = -999;
  } else if (TourSubpage || EventTour || Alcatraz) {
    navbar.treshold = 20;
  }
}

function setStickyMenuDynamically() {
  if (
    !isFullPage ||
    (isFullPage && window.innerWidth <= _mobilebreakpoint) ||
    (isFullPage && window.innerHeight < heightBreakepoint)
  ) {
    if (navbar.treshold <= window.scrollY) {
      if (!navbar.classList.contains("sticky")) {
        navbar.classList.add("sticky");
        document.body.classList.add("header-sticky");
      }
    } else {
      if (navbar.classList.contains("sticky")) {
        navbar.classList.remove("sticky");
        document.body.classList.remove("header-sticky");
      }
    }
  }
}

// New header phone button
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('/new-york')) {
    const phoneLink = document.querySelectorAll('.header-phone-block a');
    const svgTitle = document.querySelectorAll('.header-phone-block svg title');
    
    if (phoneLink) {

      phoneLink.forEach((item) => {
        item.href = 'tel:(917) 440-9094';
      })
    }
    
    if (svgTitle) {

      svgTitle.forEach((item) => {
        item.textContent = 'tel:(917) 440-9094'; 
      })
    }
  }
});

// New header visit us

document.addEventListener('DOMContentLoaded', function() {
  
  if(document.querySelector(".header-visit-us")) {

    const visitUsBlock = document.querySelectorAll(".header-visit-us");

    visitUsBlock.forEach((item) => {
      const sanFranciscoLink = item.querySelector(".san-francisco");
      const newYorkLink = item.querySelector(".new-york");
      
      if (!window.location.href.includes('/new-york')) {
        newYorkLink.classList.add("active");
      } else {
        sanFranciscoLink.classList.add("active");
      }
    })
  }
});